import { useEffect, useState } from 'react';
import { getAddressForm } from '../utils/addressForm';

const useAddressForm = (country, enabled = true) => {
  const [addressForm, setAddressForm] = useState(null);
  const [isLoading, setIsLoading] = useState(Boolean(enabled));

  useEffect(() => {
    if (!enabled) {
      setAddressForm(null);
      setIsLoading(false);
      return undefined;
    }

    let isMounted = true;

    setIsLoading(true);
    getAddressForm(country).then((resolvedForm) => {
      if (isMounted) {
        setAddressForm(resolvedForm);
        setIsLoading(false);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [country, enabled]);

  return { addressForm, isLoading };
};

export default useAddressForm;
